import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';


// =========== MDB Ui Kit ===========//

import 'mdb-react-ui-kit/dist/css/mdb.min.css';




const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  
  <React.StrictMode>
    <App />
  </React.StrictMode>
 
);


reportWebVitals();
